import { render, staticRenderFns } from "./InputMessageBox.vue?vue&type=template&id=a7392656&scoped=true&"
import script from "./InputMessageBox.vue?vue&type=script&lang=js&"
export * from "./InputMessageBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7392656",
  null
  
)

export default component.exports